import eggIcon from "../assets/images/egg-icon.svg";
import vegIcon from "../assets/images/veg-icon.svg";
import nonVegIcon from "../assets/images/nonveg-icon.svg";
import NewVegIcon from "../assets/images/new-veg-icon.png";
import NewNonvegIcon from "../assets/images/new-nonveg-icon.png";
import NewVeganIcon from "../assets/images/new-vegan-icon.png";

import md5 from "md5";
import { BASE_URL, GET_MENU, TINY_FEEDBACK_URL, ORDER_HISTORY } from "./Urls";
import PostJSON from "./PostJSON";
import { clearItemsInCart } from "../store/actionCreators/cartItems";
import { clearItemsInTempCart } from "../store/actionCreators/tempCart";
import { store } from "..";
import { setSnackbarMessage } from "../store/actionCreators/snackbarMessage";
import {
  CART_AUTO_CLEAR_MESSAGE,
  SESSION_TIME_REVERSE_MAP,
  SESSION_TIMINGS
} from "./Constants";

import { parse, isWithinInterval } from "date-fns";

// To encrypt a value
export const GET_ENCRYPTED_DATA = inputText => {
  let message = inputText;
  let hex_message = "";
  let key = "c854a23382930194caa48e66f240833c";
  for (let i = 0; i < message.length; i++) {
    let ascii_char = message.charCodeAt(i);
    hex_message += ascii_char.toString(16);
    if (i === parseInt(message.length / 2, 10)) {
      hex_message += key;
    }
  }
  return btoa(hex_message);
};

// function to disable or enable a button
export const CHECKBUTTON_STATUS = (values, excludeValues) => {
  const stateValues = { ...values };
  // excludeValue ? delete stateValues[excludeValue] : null;
  if (excludeValues) {
    // let valuesToRemove = excludeValues.split(',');

    for (let i = 0; i < excludeValues.length; i++) {
      delete stateValues[excludeValues[i]];
    }
  }
  let disabled = false;
  let keys = Object.keys(stateValues);
  for (let i = 0; i < keys.length; i++) {
    if (!stateValues[keys[i]]) {
      disabled = true;
      break;
    }
  }

  return disabled;
};

// This function decides when to show mobile/desktop layout in SignupSignin
export function isDesktop() {
  return document.documentElement.clientWidth > 1279 ? true : false;
}

//  Checks whether browser is chrome or not
export function isChrome() {
  return (
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  );
}

export function parseMenuItemObject(itemObject) {
  let objectCopy = { ...itemObject };
  let newObject = { ...objectCopy };
  newObject.extras = JSON.parse(objectCopy.extras || "{}");
  newObject.listofcategories = objectCopy.listofcategories.split(",");
  return newObject;
}

const CONVERT_STR_TO_DATE_OBJ = timeSlot => {
  let splitTimes = timeSlot.split("-");
  let startDate = new Date();
  let endDate = new Date();
  let start = splitTimes[0];
  let end = splitTimes[1];
  startDate.setHours(start.split(":")[0]);
  startDate.setMinutes(start.split(":")[1]);
  startDate.setSeconds(0);
  endDate.setHours(end.split(":")[0]);
  endDate.setMinutes(end.split(":")[1]);
  endDate.setSeconds(0);
  let startTime = startDate;
  let endTime = endDate;
  return { startTime, endTime };
};

export const CHECK_FOR_PRE_BOOK_SESSSION = (
  timestring = "",
  preOrderDetailsFromStore = {},
  getPreOrderDataFromStore,
  sessionsData = {},
  getSessionsDataFromStore
) => {
  let preOrderData = { ...preOrderDetailsFromStore };
  let sessionsDetails = { ...sessionsData };
  if (Object.keys(preOrderData).length <= 0 && getPreOrderDataFromStore) {
    preOrderData = store.getState().preorderData || {};
    // sessionsDetails = store.getState().sessionsData || {};
    // activePass = cafePass.activePass || {};
    // cafePassList    = cafePass.cafePassList;
  }
  if (Object.keys(sessionsDetails).length <= 0 && getSessionsDataFromStore) {
    sessionsDetails = store.getState().sessionsData || {};
  }
  let matched = true;
  let checkFurther = true;

  if (Object.keys(preOrderData).length <= 0) {
    return { matched, checkFurther };
    // add back up functionalities later
  }
  checkFurther = false;

  const { date, session } = preOrderData;
  // const { startTime, exitBy } = activePass || {};
  // const preOrderSessionTimings = SESSION_TIMINGS[session];
  // const preOrderSessionTimings = sessionsDetails[session] || {};
  // let { startTime: sessStart, endTime: sessEnd } = CONVERT_STR_TO_DATE_OBJ(
  //   preOrderSessionTimings
  // );

  // let timestamps = timestring.split(",") || [];
  matched = false;

  // if (timestamps.length > 0) {
  //   for (let i = 0; i < timestamps.length; i++) {
  //     let { startTime: start, endTime: end } = CONVERT_STR_TO_DATE_OBJ(
  //       timestamps[i]
  //     );

  //     if (sessStart >= start && sessEnd <= end) {
  //       matched = true;
  //       break;
  //     }
  //   }
  // }

  if (SESSION_TIME_REVERSE_MAP[timestring] === session) {
    matched = true;
  }

  if (sessionsDetails.hasOwnProperty(session)) {
    matched = true;
  }

  return { matched, checkFurther };
};

// checks if the current time falls in any of the values given in the timestring
export const CHECK_AVAILAIBILITY = (
  timestring,
  cafePass = {},
  getFromStore = true,
  preOrderData = {},
  getPreOrderDataFromStore = true,
  sessionsData = {},
  getSessionsDataFromStore = true
) => {
  if (!timestring) return true;
  let isPreOrder = Object.keys(preOrderData).length > 0;
  if (!isPreOrder && getPreOrderDataFromStore) {
    isPreOrder = Object.keys(store.getState().preorderData || {}).length > 0;
  }
  let matched = false;
  if (isPreOrder) {
    let { checkFurther, matched } = CHECK_FOR_PRE_BOOK_SESSSION(
      timestring,
      preOrderData,
      getPreOrderDataFromStore,
      sessionsData,
      getSessionsDataFromStore
    );
    if (!checkFurther) return matched;
  }
  let { available, furtherCheck } = CHECK_ACTIVE_PASS_TIMINGS(
    timestring,
    cafePass,
    getFromStore
  );
  if (!furtherCheck) return available;

  let timestamps = timestring.split(",");
  let currentTime = new Date();
  available = false;
  matched = false;
  for (let i = 0; i < timestamps.length; i++) {
    let { startTime, endTime } = CONVERT_STR_TO_DATE_OBJ(timestamps[i]);
    if (startTime <= currentTime && currentTime <= endTime) {
      available = true;
      matched = true;
    }
  }

  let preOrderDetails;
  if (getPreOrderDataFromStore) {
    preOrderDetails = store.getState().preorderData || {};
  } else {
    preOrderDetails = preOrderData;
  }
  if (Object.keys(preOrderDetails).length) {
    return matched;
  }
  return available;
};

export const IS_PASS_EXPIRED = () => {
  let passExpired = false;

  const { cafePass = {} } = store.getState() || {};
  const { activePass = {} } = cafePass;
  if (Object.keys(activePass).length <= 0) {
    return passExpired;
  }
  const { exitBy = "", date } = activePass;
  let passDateTime = new Date();
  const [hr, min] = exitBy.split(":");
  passDateTime.setHours(hr);
  passDateTime.setMinutes(parseInt(min) - 5); // to stop ordering before 5 min
  passDateTime.setSeconds(0);
  if (date) {
    const [dd, mm, yyyy] = date.split("-");
    passDateTime.setDate(dd);
    passDateTime.setMonth(mm - 1);
    passDateTime.setFullYear(yyyy);
  }
  const dateTimeNow = new Date();
  if (dateTimeNow >= passDateTime) {
    passExpired = true;
  }

  return passExpired;
};

export const CHECK_ACTIVE_PASS_TIMINGS = (
  timestring,
  cafePassParent,
  getFromStore
) => {
  let cafePass = { ...cafePassParent };
  let { activePass = {} } = cafePass;
  if (Object.keys(activePass).length <= 0 && getFromStore) {
    cafePass = store.getState().cafePass || {};
    activePass = cafePass.activePass || {};
    // cafePassList    = cafePass.cafePassList;
  }
  let available = true;
  let furtherCheck = true;

  if (Object.keys(activePass).length <= 0 || !IS_TODAY(activePass.date)) {
    return { available, furtherCheck };
    // add back up functionalities later
  }
  furtherCheck = false;

  const { startTime, exitBy } = activePass || {};
  let { startTime: passStart, endTime: passEnd } = CONVERT_STR_TO_DATE_OBJ(
    `${startTime}-${exitBy}`
  );

  let timestamps = timestring.split(",");
  available = false;

  for (let i = 0; i < timestamps.length; i++) {
    let { startTime: start, endTime: end } = CONVERT_STR_TO_DATE_OBJ(
      timestamps[i]
    );

    if (passStart >= start && passEnd <= end) {
      available = true;
    }
  }
  return { available, furtherCheck };
};

// checks if the key is present inside the data object,
// if present, searches for the searchParam and if it matches
// returns true, else returns false
export const SEARCH_PARAMETER = (data, key, searchParam) => {
  let isPresent = false;
  if (data[key]) {
    let val = data[key].toLowerCase();
    if (val.includes(searchParam)) {
      console.log(val, searchParam);
      isPresent = true;
    }
  }
  return isPresent;
};

// checks if the key is present in the data object,
// if present, checks if any of the value from listOfValues matches
// the key's value, if there's a match, returns true, else returns false
export const SEARCH_FROM_LIST = (data, key, listOfValues) => {
  let isPresent = false;
  if (data[key]) {
    let val = data[key].toLowerCase();
    // if listOfValues is not an array (maybe a string/json) return false
    if (Array.isArray(listOfValues)) {
      listOfValues.filter(value => {
        let vals = value.toLowerCase() === val;
        if (vals) isPresent = true;
      });
    }
  }
  return isPresent;
};

export const CREATE_PAIR = (keys, values) => {
  let output = [];
  for (let i = 0; i < keys.length; i++) {
    const value = { [keys[i]]: values[keys[i]] };
    output.push(value);
  }

  return output;
};

export const ITEM_TAX_CALCULATION = (taxObj, totalPrice) => {
  // individual tax percentage
  let cgstPerc = taxObj.cgsttax || 0;
  let sgstPerc = taxObj.sgsttax || 0;
  let ugstPerc = taxObj.ugsttax || 0;
  let cessPerc = taxObj.cesstax || 0;

  let totalTaxPerc = cgstPerc + sgstPerc + ugstPerc + cessPerc;
  let grossAmt = (totalPrice * 100) / (100 + totalTaxPerc); // total price before tax

  let cgstAmt = (grossAmt * cgstPerc) / 100;
  let sgstAmt = (grossAmt * sgstPerc) / 100;
  let ugstAmt = (grossAmt * ugstPerc) / 100;
  let cessAmt = (grossAmt * cessPerc) / 100;

  let taxAmtObj = {
    cgstAmt,
    sgstAmt,
    ugstAmt,
    cessAmt
  };

  let totalTaxAmt = cgstAmt + sgstAmt + ugstAmt + cessAmt; // total tax amount
  totalTaxAmt = Math.round(totalTaxAmt * 100) / 100;
  grossAmt = Math.round(grossAmt * 100) / 100;

  return {
    totalTaxAmt,
    grossAmt,
    taxAmtObj
  };
};

export const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

export function getIcon(type) {
  switch (type) {
    case "V":
      // return vegIcon;
      return NewVegIcon;
    case "E":
      return NewNonvegIcon;
    case "N":
      return NewNonvegIcon;
    case "P":
      return NewVeganIcon;
    default:
      return vegIcon;
  }
}

export const HEX_BYTE_STRING_TO_BYTE_ARRAY = hexByteString => {
  var bytes = new Array(16); // this could also be a new Uint8array(16)
  for (var i = 0; i < hexByteString.length; ) {
    var hexByte = hexByteString[i++] + hexByteString[i++];
    var byte = parseInt(hexByte, 16);
    bytes[i / 2 - 1] = byte;
  }
  return bytes;
};

export const PAD_NUMBER = (n, width) => {
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join("0") + n;
};

export const GET_MD5_HASHED_BYTE_ARRAY_VALUE = userID => {
  let hexHash = md5(userID);
  const bytes = HEX_BYTE_STRING_TO_BYTE_ARRAY(hexHash);
  const random_element = bytes[Math.floor(Math.random() * bytes.length)];
  return PAD_NUMBER(random_element, 3);
};

export const GENERATE_ORDER_ID = (userID, IDBeginner) => {
  let orderID = IDBeginner;
  let possible = "ABDEFGHIJKLMNOPQRSTUVWXY";
  orderID += possible.charAt(Math.floor(Math.random() * possible.length));
  // orderID += "8867131593".substr("8867131593".length - 3);
  orderID += GET_MD5_HASHED_BYTE_ARRAY_VALUE(userID);
  orderID += "Z";
  let today = new Date();
  orderID +=
    "" +
    today.getFullYear().toString().substr(-2) +
    (today.getMonth() + 1) +
    today.getDate() +
    today.getHours() +
    today.getMinutes() +
    today.getSeconds() +
    today.getMilliseconds();
  // orderID += Math.floor(Math.random() * 1000);
  console.log(orderID);

  return orderID;
};

export const GET_URL_PARAMETER_BY_NAME = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

// "library" of visibility management
//  var visible = vis(); // gives the current state
//  vis(function(){});   // defines a handler for visibility changes
export const CHECK_TAB_ACTIVE = () => {
  let stateKey,
    eventKey,
    keys = {
      hidden: "visibilitychange",
      webkitHidden: "webkitvisibilitychange",
      mozHidden: "mozvisibilitychange",
      msHidden: "msvisibilitychange"
    };
  for (stateKey in keys) {
    if (stateKey in document) {
      eventKey = keys[stateKey];
      break;
    }
  }
  return !document[stateKey];
};

export const handleVisibilityChange = override => {
  let { getState, dispatch } = store;
  let state = (window._clearCart || {}).state;
  if (!(override === true) && !state) {
    return;
  }
  if (!(override === true) && document[state]) {
    //hidden
  } else {
    let cartExpiry = localStorage.getItem("cartExpiry");
    if (!cartExpiry) {
      return;
    }

    let currentDate = new Date();
    if (currentDate.toDateString() !== cartExpiry) {
      const { tempCart } = getState() || {};
      let toBeCleared = Object.keys(tempCart);

      if (!window.tempCartData) {
        window.tempCartData = {};
      }
      toBeCleared.map(foodId => {
        window.tempCartData[foodId] = true;
      });

      dispatch(clearItemsInCart());
      dispatch(clearItemsInTempCart());
      dispatch(setSnackbarMessage(CART_AUTO_CLEAR_MESSAGE));
    }
  }
};

export const registerAutoCartClear = () => {
  handleVisibilityChange(true);
  var hidden, visibilityChange;
  if (typeof document.hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }

  if (window._clearCart) {
    document.removeEventListener(
      visibilityChange,
      window._clearCart.handleVisibilityChange,
      false
    );
  }

  if (!window._clearCart) {
    window._clearCart = {};
  }
  window._clearCart = {
    state: hidden,
    handler: handleVisibilityChange
  };

  if (
    typeof document.addEventListener === "undefined" ||
    hidden === undefined
  ) {
    console.log(
      "This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API."
    );
  } else {
    // Handle page visibility change
    document.addEventListener(
      visibilityChange,
      window._clearCart.handler,
      false
    );
  }
};

export const cartUpdated = () => {
  let date = new Date();
  localStorage.setItem("cartExpiry", date.toDateString());
};

// vis(function(){
// 	document.title = vis() ? 'Visible' : 'Not visible';
// 	console.log(new Date, 'visible ?', vis());
// });

// to set the initial state
// document.title = vis() ? 'Visible' : 'Not visible';

export function ordinal_suffix_of(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}

// send input date in dd-mm-yyyy format
export const IS_TODAY = inputDate => {
  const orderDateValues = inputDate.split("-");
  const currentOrderDate = orderDateValues[0];
  const currentOrderMonth = orderDateValues[1];
  const currentOrderYear = orderDateValues[2];
  let orderDateStamp = new Date();
  orderDateStamp.setDate(currentOrderDate);
  orderDateStamp.setMonth(currentOrderMonth - 1);
  orderDateStamp.setFullYear(currentOrderYear);
  const today = new Date();
  let isToday = false;
  if (
    orderDateStamp.getDate() === today.getDate() &&
    orderDateStamp.getMonth() === today.getMonth() &&
    orderDateStamp.getFullYear() === today.getFullYear()
  ) {
    isToday = true;
  }
  return isToday;
};

export const GET_SHORT_ORDERID = full_orderid => full_orderid.split("Z")[0];

export const getFormattedTimings = timings => {
  if (timings === "0:0-23:59" || timings === "00:00-23:59") {
    return "24 hours open";
  }

  let [start, end] = timings.split("-");

  function formatTime(time) {
    let meridiem = "";
    let [hours, minutes] = time.split(":");

    hours = parseInt(hours);
    minutes = parseInt(minutes);

    if (minutes === 0) {
      minutes = "00";
    } else if (minutes === 59) {
      minutes = "00";
      hours += 1;
    }

    if (hours === 0) {
      hours = 12;
      meridiem = "AM";
    } else if (hours === 12) {
      hours = 12;
      meridiem = "PM";
    } else if (hours > 12) {
      hours -= 12;
      meridiem = "PM";
    } else {
      if (hours < 10) {
        hours = "0" + hours;
      }
      meridiem = "AM";
    }

    return `${hours}:${minutes} ${meridiem}`;
  }

  let startTime = formatTime(start);
  let endTime = formatTime(end);

  return `${startTime} - ${endTime}`;
};

export const checkIfDifferentRestaurant = foodid => {
  // const {
  //   menuDetails
  // } = this.props;
  // const incomingId = menuDetails["foodid"];
  const state = localStorage.getItem("state");
  const cartItems = JSON.parse(state)["cartItems"];
  const currentId = Object.keys(cartItems)[0];
  let isDifferentRestaurant = false;
  if (currentId) {
    let currentConstructedId =
      currentId.split(":")[0] + "-" + currentId.split(":")[1];
    let incomingConstructedId =
      foodid.split(":")[0] + "-" + foodid.split(":")[1];
    // console.log('currentConstructedId :', currentConstructedId);
    // console.log('incomingConstructedId :', incomingConstructedId);
    if (currentConstructedId !== incomingConstructedId) {
      // console.log('DIFFERNT LOCATIONS :');
      isDifferentRestaurant = true;
      // this.props.setAlertPopup("Different Locations");
    }
  }

  return isDifferentRestaurant;
};

export const checkIfDifferentFoodCourt = (cart, foodid) => {
  const currentId = Object.keys(cart)[0];
  let isDifferentFoodCourt = false;
  if (currentId) {
    let currentConstructedId = currentId.split(":")[0];
    let incomingConstructedId = foodid.split(":")[0];
    if (currentConstructedId !== incomingConstructedId) {
      isDifferentFoodCourt = true;
    }
  }

  return isDifferentFoodCourt;
};

export const IS_RESTUARANT_IN_ACTIVE = ({
  restaurantIsAlive,
  servingTime,
  isBuffet
}) => {
  if (CHECK_AVAILAIBILITY(servingTime)) {
    if (!isBuffet && !restaurantIsAlive) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const IS_SAME_FILTER = (currentFilters, selectedFilter) => {
  let currentFiltersTemp = [...currentFilters];
  let selectedFilterTemp = [...selectedFilter];

  if (selectedFilterTemp.length === 0) {
    selectedFilterTemp = ["V", "E", "N"];
  }
  if (currentFiltersTemp.length === selectedFilterTemp.length) {
    currentFiltersTemp = currentFiltersTemp.sort().toString();
    selectedFilterTemp = selectedFilterTemp.sort().toString();
    if (currentFiltersTemp === selectedFilterTemp) {
      return true;
    }
  }

  return false;
};

export const ARRANGE_CATEGORIES = props => {
  let searchedItemsText = "Searched Items";
  let notAvailableKey = "Unavailable Items";
  const { menuList, currentSession, currentRestaurantDetails } = props;
  let categoriesList = Object.keys(menuList[currentSession] || {});
  let orderedCategoriesList = currentRestaurantDetails.Mlist.listofcat || [];

  let allItemsOutOfStock = true;
  categoriesList.sort((a, b) => {
    const indexA = orderedCategoriesList.indexOf(a);
    const indexB = orderedCategoriesList.indexOf(b);
    return indexA - indexB;
  });
  // categoriesList.map(category => {
  //   if (category === searchedItemsText || category === notAvailableKey) {
  //     return;
  //   }
  //   if (menuList[currentSession][category].length !== 0) {
  //     allItemsOutOfStock = false;
  //     return;
  //   }
  // });

  const newLabels = [];

  categoriesList.forEach(el => {
    if (orderedCategoriesList.includes(el)) {
      newLabels.push(el);
    } else if (el !== searchedItemsText && el !== notAvailableKey) {
      newLabels.unshift(el);
    }

    if (menuList[currentSession][el].length) {
      allItemsOutOfStock = false;
    }
  });
  orderedCategoriesList = newLabels;

  let categoryIndex = categoriesList.indexOf(notAvailableKey);
  if (categoryIndex !== -1) {
    if (allItemsOutOfStock) {
      orderedCategoriesList = [notAvailableKey, ...orderedCategoriesList];
    } else {
      orderedCategoriesList = [...orderedCategoriesList, notAvailableKey];
    }
  }

  categoryIndex = categoriesList.indexOf(searchedItemsText);
  if (categoryIndex !== -1) {
    orderedCategoriesList = [searchedItemsText, ...orderedCategoriesList];
  }

  return orderedCategoriesList;
};

export const GET_DISPLAY_NAME = userDetails => {
  const { userid, name, employeeid, fullname } = userDetails;
  let possibleNameToBeDisplayed = [fullname, name, employeeid, userid];

  for (let value of possibleNameToBeDisplayed) {
    if (typeof value === "string" && value.trim() !== "") {
      return value;
    }
  }
};
// -------------TBD-------------------------
export const CONVERT_STR_TO_HEX = strVal => {
  let output = "";
  for (let i = 0; i < strVal.length; i++) {
    output += "" + strVal.charCodeAt(i).toString(16);
  }

  return output;
};

export const CONVERT_HEX_TO_DECIMAL_ARRAY = value => {
  // let output = "";
  let output = [];
  for (let i = 0; i < value.length; i++) {
    // output += parseInt(value[i], 16);
    output.push(parseInt(value[i], 16));
  }

  return output;
};

export const CALCULATE_SUM = val => {
  let output = 0;
  for (let i = 0; i < val.length; i++) {
    output += parseInt(val[i]);
  }

  return output;
};

export const GENERATE_ORDERID_REST_HASH = value => {
  let hexVal = CONVERT_STR_TO_HEX(value);
  let hexToDec = CONVERT_HEX_TO_DECIMAL_ARRAY(hexVal);
  let sum = CALCULATE_SUM(hexToDec);

  return sum.toString();
};
// ----------------------------------------------

export const GET_PROCESSED_OBJECT = (headers, values) => {
  // console.log("process Restaurant function called");
  let headerValuesLength = Object.keys(headers).length;
  let numberOfRestaurants = Object.keys(values).length;
  let processedRestInfo = [];

  for (let i = 0; i < numberOfRestaurants; i++) {
    let individualRestAttributes = {};
    for (let j = 0; j < headerValuesLength; j++) {
      individualRestAttributes[headers[j]] = values[i][j];
    }
    processedRestInfo.push(individualRestAttributes);
  }

  // this.setState({ restaurantsInfo: processedRestInfo });
  // console.log("processedRestInfo", processedRestInfo);
  return processedRestInfo;
};

export const CHECK_RESTAURANT_AVAILABILITY = (
  restTimings,
  isBuffet,
  restid,
  restAlive
) => {
  const restAliveTiming = CHECK_AVAILAIBILITY(restTimings);
  let isAvailable = false;
  if (restAliveTiming) {
    if (isBuffet) {
      isAvailable = true;
    } else {
      for (let i = 0; i < restAlive.length; i++) {
        if (restAlive[i] === restid) {
          isAvailable = true;
        }
      }
    }
  }

  return isAvailable;
};

const GET_IND_REST_DETAILS = (restid, restList = []) => {
  return restList.filter(r => r.uniqid === restid)[0] || {};
};

const GET_ACTIVE_REST_BY_ORDER = (activeRestaurants = [], sequence = []) => {
  let result = [];
  let allRestIds = activeRestaurants.map(r => r.uniqid);
  sequence.forEach(restid => {
    let restDetails = GET_IND_REST_DETAILS(restid, activeRestaurants);
    Object.keys(restDetails).length > 0 && result.push(restDetails);
  });
  allRestIds.forEach(rId => {
    if (!sequence.includes(rId)) {
      let restValues = GET_IND_REST_DETAILS(rId, activeRestaurants);
      Object.keys(restValues).length > 0 && result.push(restValues);
    }
  });

  return result;
};

export const SORT_REST_BY_ACTIVE = (
  restaurantsInfo = [],
  restAlive = [],
  restSequence = []
) => {
  let activeRestaurants = [];
  let inactiveRestaurants = [];
  for (let i = 0; i < restaurantsInfo.length; i++) {
    if (
      CHECK_RESTAURANT_AVAILABILITY(
        restaurantsInfo[i]["servingtime"],
        restaurantsInfo[i]["extras"]["isbuffet"],
        restaurantsInfo[i]["uniqid"],
        restAlive
      )
    ) {
      activeRestaurants.push(restaurantsInfo[i]);
    } else {
      inactiveRestaurants.push(restaurantsInfo[i]);
    }
  }

  if (restSequence.length > 0) {
    activeRestaurants = GET_ACTIVE_REST_BY_ORDER(
      activeRestaurants,
      restSequence
    );
    inactiveRestaurants = GET_ACTIVE_REST_BY_ORDER(
      inactiveRestaurants,
      restSequence
    );
  }

  let sortedRestaurantsList = activeRestaurants.concat(inactiveRestaurants);

  return sortedRestaurantsList;
};

export const processCentralData = data => {
  const { Mlist: menuList, FoodNa, loginextras, restextras } = data;
  let { favourites, likes } = loginextras.extras;
  const { display_pre_gst_amount } = restextras;
  favourites = favourites || [];
  likes = likes || [];
  let { values, allsubmenu } = menuList;
  let subMenuCategories = Object.keys(allsubmenu.attributes || {});
  let centralData = {};

  if (values.length === 0) {
    // this.props.history.replace(DASHBOARD_PAGE_URL, {
    //   dontRedirect: true
    // });
    //TODO show dialog
  }

  const headers = menuList.headers.reduce((accumulator, value, index) => {
    accumulator[value] = index;
    return accumulator;
  }, {});

  centralData = values.reduce((accumulator, value) => {
    let sessionsList = value[headers["extras"]]["session_list"];
    let categories = value[headers["listofcategories"]].split(",");

    let itemObj = {};
    let includeKeys = [
      "foodid",
      "foodname",
      "fooddescription",
      "servingtime",
      "vegflag",
      "extras",
      "price",
      "submenu",
      "offertext"
    ];
    itemObj = includeKeys.reduce((accumulator, key) => {
      accumulator[key] = value[headers[key]];
      return accumulator;
    }, {});

    if (display_pre_gst_amount) {
      const { cgsttax, cesstax, sgsttax, ugsttax } = itemObj["extras"];
      const taxObj = { cgsttax, cesstax, sgsttax, ugsttax };
      const { grossAmt, totalTaxAmt } = ITEM_TAX_CALCULATION(
        taxObj,
        itemObj.price
      );
      itemObj["preTaxPrice"] = grossAmt;
      itemObj["taxAmount"] = totalTaxAmt;
    }

    itemObj["submenu"] = itemObj["submenu"].filter(category => {
      return subMenuCategories.includes(category);
    });
    let servingFlag = CHECK_AVAILAIBILITY(itemObj.servingtime);
    itemObj["servingFlag"] = servingFlag;
    itemObj["sessions"] = sessionsList;
    itemObj["listofcategories"] = categories;

    itemObj["outofstock"] = false;
    if (FoodNa.includes(itemObj["foodname"].toLowerCase())) {
      itemObj["outofstock"] = true;
    }

    // itemObj["like"] = false;
    // if (likes.includes(itemObj["foodid"])) {
    //   itemObj["like"] = true;
    // }

    itemObj["favorite"] = false;
    if (favourites.includes(itemObj["foodid"])) {
      itemObj["favorite"] = true;
    }

    accumulator[itemObj["foodid"]] = itemObj;

    return accumulator;
  }, {});

  return centralData;
};

export const GET_ALLERGENS = data => {
  let allAllergens = [];
  Object.keys(data).map(item => {
    let { extras: { nutritionInfo: { allergens = [] } = {} } = {} } = data[
      item
    ];
    allAllergens = [...allAllergens, ...allergens];
  });
  allAllergens = new Set(allAllergens);
  return [...allAllergens].sort();
};

export const GET_RESTID_LIST = cartItems => {
  if (cartItems && Object.keys(cartItems).length > 0) {
    let cartItemIds = Object.keys(cartItems);
    let restaurantIds = {};
    cartItemIds.map(item => {
      let constructedId = item.split(":");
      constructedId = `${constructedId[0]}:${constructedId[1]}`;
      restaurantIds[constructedId] = true;
    });
    return Object.keys(restaurantIds);
  }
  return [];
};

export const processSubMenu = data => {
  const { FoodNa, allSubMenu } = data;
  if (!allSubMenu) {
    return {};
  }

  const { list, options, attributes } = allSubMenu;
  list.map(subCategory => {
    const { ismand, multiple, min, max } = attributes[subCategory];
    let subCategoryOptions = Object.keys(options[subCategory]);
    subCategoryOptions = subCategoryOptions.filter(
      subItem => !FoodNa.includes(subItem.toLowerCase())
    );
    const subCategoryOptionsCount = subCategoryOptions.length;

    let statusFlag = false;
    let optionalFlag = false;
    if (ismand) {
      if (multiple) {
        if (subCategoryOptionsCount < min) {
          statusFlag = true;
        }
      } else {
        if (subCategoryOptionsCount < 1) {
          statusFlag = true;
        }
      }
    } else {
      if (multiple) {
        if (subCategoryOptionsCount < min) {
          optionalFlag = true;
        }
      } else {
        if (subCategoryOptionsCount < 1) {
          optionalFlag = true;
        }
      }
    }
    allSubMenu.attributes[subCategory].outOfStockStatus = statusFlag;
    allSubMenu.attributes[subCategory].optionalStatus = optionalFlag;
  });

  return allSubMenu;
};

export const DATA_URL_TO_FILE = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const GET_12HR_TIME_FORMAT = time => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const extractRestName = item => {
  let itemSplitVals = item.split(":");
  return itemSplitVals[1];
};

export const CONSTRUCT_RESTS_OBJECT_FROM_CART = cartItems => {
  let itemKeys = Object.keys(cartItems);
  let restaurantObj = {};
  itemKeys.forEach(item => {
    let restaurant = extractRestName(item).toLowerCase();
    if (restaurant in restaurantObj) {
      restaurantObj[restaurant] += 1;
    } else {
      restaurantObj[restaurant] = 1;
    }
  });

  return restaurantObj;
};

export const CALCULATE_TOTAL_AND_TAXES = (cartItems, taxObject) => {
  const foodids = Object.keys(cartItems);
  let grandTotal = 0;
  let taxes = 0;
  foodids.map(foodid => {
    const { computedPrice, price, gstPrice, quantity, preTaxPrice } = cartItems[
      foodid
    ];
    grandTotal += (gstPrice || computedPrice || price) * quantity;
  });

  const restIDs = Object.keys(taxObject || {});
  restIDs.map(restid => {
    taxes += taxObject[restid].reduce((total, obj) => {
      return total + obj.portion;
    }, 0);
  });
  const subTotal = grandTotal - taxes;
  return { grandTotal, subTotal, taxes };
};

export const fetchMutliRestaurantDetails = (
  args,
  successCallback,
  errorCallback
) => {
  let {
    cartItems,
    setErrorMessage,
    updateImmutableMultiSubMenu,
    updateMultiRestaurantDetails,
    storeCartItems
  } = args;
  let restaurantList = GET_RESTID_LIST(cartItems);
  const body = {
    restaurantlist: restaurantList,
    ordertype: "dinein",
    sender: "web",
    cookie: "",
    scheduledslot: undefined
  };

  PostJSON(
    BASE_URL + GET_MENU,
    body,
    response => {
      const data = response.extras;
      // const { resturantalive, restextras } = response.extras;
      // const { isbuffet, genservingtime, display_pre_gst_amount } = restextras;
      // if (
      //   IS_RESTUARANT_IN_ACTIVE({
      //     restaurantIsAlive: resturantalive,
      //     servingTime: genservingtime,
      //     isBuffet: isbuffet
      //   })
      // ) {
      //   setErrorMessage(
      //     "Restaurant is offline. Please select items from another restaurant."
      //   );

      //   storeCartItems({});
      //   }

      let multiRestaurantDetails = {};
      let multiSubMenu = {};
      let cart = {};
      let newCount = 0;
      let removedItems = [];

      for (let i = 0; i < restaurantList.length; i++) {
        let currentRestaurantId = restaurantList[i];

        data[currentRestaurantId]["loginextras"] = data["loginextras"];

        multiRestaurantDetails[currentRestaurantId] = data[currentRestaurantId];

        const { Mlist: menuList, FoodNa, restextras } = data[
          currentRestaurantId
        ];
        const { display_pre_gst_amount } = restextras;
        let allSubMenu = processSubMenu({
          allSubMenu: menuList["allsubmenu"],
          FoodNa
        });
        multiSubMenu[currentRestaurantId] = allSubMenu;

        let centralData = {};
        centralData = processCentralData(data[currentRestaurantId]);

        let cartItemKeys = Object.keys(cartItems);
        cartItemKeys = cartItemKeys.filter(item => {
          return item.startsWith(currentRestaurantId);
        });

        let newCart = {};

        newCart = cartItemKeys.reduce((accumulator, itemKey) => {
          let id = itemKey.split("~")[0];
          let itemInfo = centralData[id];
          let hasSubMenu;

          if (!itemInfo) {
            removedItems.push(cartItems[itemKey].foodName);
            return accumulator;
          }

          if ((itemInfo["submenu"] || []).length === 0) {
            hasSubMenu = false;
            id = `${id}~0`;
          } else {
            hasSubMenu = true;
            newCount += 1;
            id = `${id}~${newCount}`;
          }

          if (!accumulator[id]) {
            accumulator[id] = { ...cartItems[itemKey] };
          } else {
            accumulator[id].quantity += cartItems[itemKey].quantity;
          }

          accumulator[id]["price"] = itemInfo["price"];
          accumulator[id]["vegflag"] = itemInfo["vegflag"];
          accumulator[id]["servingtime"] = itemInfo["servingtime"];

          if (hasSubMenu) {
            accumulator[id]["submenu"] = itemInfo["submenu"];

            let selectedSubMenu = [];
            let orderSelectedSubMenu =
              accumulator[id]["unprocessedSelectedSubMenu"] || [];
            let orderSubCategories = Object.keys(orderSelectedSubMenu);
            orderSubCategories.map(subCategory => {
              orderSelectedSubMenu[subCategory].map(subItem => {
                selectedSubMenu.push({
                  subCategory,
                  subMenuItem: subItem,
                  price: allSubMenu.options[subCategory][subItem]
                });
              });
            });

            if (!accumulator[id].selectedSubMenu) {
              accumulator[id].selectedSubMenu = selectedSubMenu;
            }
          } else {
            accumulator[id]["submenu"] = [];
          }
          delete accumulator[id]["unprocessedSelectedSubMenu"];

          if (display_pre_gst_amount) {
            const { cgsttax, cesstax, sgsttax, ugsttax } = itemInfo["extras"];
            const taxObj = { cgsttax, cesstax, sgsttax, ugsttax };
            const { grossAmt, totalTaxAmt } = ITEM_TAX_CALCULATION(
              taxObj,
              itemInfo.price
            );
            accumulator[id]["preTaxPrice"] = grossAmt;
            accumulator[id]["taxAmount"] = totalTaxAmt;
          }

          return accumulator;
        }, newCart);

        cart = { ...cart, ...newCart };
      }

      if (removedItems.length !== 0) {
        setErrorMessage(
          "Sorry, Item(s) - " +
            removedItems.join(", ") +
            " have gone out of stock. Please choose another item"
        );
      }

      storeCartItems(cart);
      updateMultiRestaurantDetails(multiRestaurantDetails);
      updateImmutableMultiSubMenu(multiSubMenu);

      localStorage.removeItem("processCart");

      if (typeof successCallback === "function") {
        successCallback();
      }
    },
    error => {
      if (typeof errorCallback === "function") {
        errorCallback(error);
      }
    }
  );
};

export const GET_REST_DETAILS = (multiRestDetails, key) => {
  const restIDs = Object.keys(multiRestDetails);
  return (multiRestDetails[restIDs[0]] || {})[key] || {};
};

export const GET_ITEMS_AND_REST_COUNT = cartItems => {
  const foodids = Object.keys(cartItems);
  let itemsCount = foodids.length;
  const restList = foodids.map(foodid => {
    const idArr = foodid.split(":");
    return `${idArr[0]}:${idArr[1]}`;
  });
  const foodcourtID = restList.length > 0 ? restList[0].split(":")[0] : "";
  const restCount = [...new Set(restList)].length;
  return { itemsCount, restCount, foodcourtID };
};

export const GET_MULTIREST_CART_MAPPING = (
  multiRestaurantDetails,
  cartItems
) => {
  let restCartMapping = { ...multiRestaurantDetails };
  Object.keys(restCartMapping).map(restid => {
    delete restCartMapping[restid].cartItems;
  });
  const foodids = Object.keys(cartItems);
  foodids.map(foodid => {
    const itemObj = cartItems[foodid];
    const idArr = foodid.split(":");
    const restid = `${idArr[0]}:${idArr[1]}`;
    if (!restCartMapping[restid].cartItems) {
      restCartMapping[restid].cartItems = {};
    }
    restCartMapping[restid].cartItems[foodid] = itemObj;
  });
  return { restCartMapping };
};

export const debounce = (fn, time) => {
  let timeout;

  return function () {
    const functionCall = () => fn.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

export const closeAllDialogs = () => {
  let x = document.documentElement.clientWidth - 1;
  let y = 100;
  let element = document.elementFromPoint(x, y);
  if (element.id !== "js-sessions") {
    element.click();
  }
};

const PARSE_PAYMENT_DATA = (paymentsplit = {}, freecredits = 0) => {
  // ------------ free credits calculations ------------------------------
  let paymentObj = { ...paymentsplit };
  let employerWalletValue = paymentObj["credits"];
  if (freecredits && paymentObj["credits"]) {
    employerWalletValue =
      paymentObj["credits"] >= freecredits
        ? paymentObj["credits"] - freecredits
        : 0;
    paymentObj["credits"] = employerWalletValue;
    paymentObj["freecredits"] = freecredits;
  }

  // ------------- delete zero values / undefined values if present ------
  Object.keys(paymentObj).forEach(paymode => {
    if (!paymode || !paymentObj[paymode]) delete paymentObj[paymode];
  });

  return paymentObj;
};

export const GET_PAYMENT_STATEMENT = (
  paymentsplit = {},
  paymentMap = {},
  freecredits = 0
) => {
  let paymentDataObj = PARSE_PAYMENT_DATA(paymentsplit, freecredits);
  let finalPayStatement = Object.keys(paymentDataObj).reduce((acc, cur) => {
    let paymentLabel = paymentMap[cur] ? paymentMap[cur] : cur;
    let statement = `${paymentLabel}: ${parseFloat(paymentDataObj[cur]).toFixed(
      2
    )}`;
    if (acc) {
      return `${acc}, ${statement}`;
    }

    return `${statement}`;
  }, "");

  return finalPayStatement;
};

export const CAPITALIZE = s => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const FORM_FEEDBACK_URL = () => {
  let url = "";
  let orderDetails =
    JSON.parse(localStorage.getItem("recentOrderDetails")) || {};
  if (Object.keys(orderDetails).length == 0) {
    return url;
  }

  const { orderids = [] } = orderDetails;
  url = `${TINY_FEEDBACK_URL}?orderid=${orderids.join(",")}`;
  return url;
};

export const GET_DOCUMENT_COOKIE = cname => {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
};

export const GET_USER_TOKEN = () => {
  const token = GET_URL_PARAMETER_BY_NAME("token");
  const location = GET_URL_PARAMETER_BY_NAME("location");
  const mobileno = GET_URL_PARAMETER_BY_NAME("mobileno");
  const city = GET_URL_PARAMETER_BY_NAME("city");
  // const userToken = GET_DOCUMENT_COOKIE("token");
  return { token, location, mobileno, city };
};

export const GET_NEW_HIDECHECKOUT_OBJ = (cart, objectOg) => {
  let restids = GET_RESTID_LIST(cart);
  let obj = { ...objectOg };
  let objKeys = Object.keys(obj);
  objKeys.forEach(key => {
    if (!restids.includes(key)) {
      delete obj[key];
    }
  });
  return obj;
};

export const CHECK_IF_PREORDER = (preorderdata = {}) => {
  if (Object.keys(preorderdata).length) {
    const { date, session } = preorderdata;
    if (date && session) {
      return true;
    }
  }

  return false;
};

export const GET_PREORDER_SESSION = (preorderTime = "", sessionsData = {}) => {
  if (!preorderTime) return null;

  // let preOrderSession = Object.keys(SESSION_TIMINGS).find(el =>
  let preOrderSession = Object.keys(sessionsData).find(el =>
    // SESSION_TIMINGS[el].includes(preorderTime)
    sessionsData[el].includes(preorderTime)
  );
  if (preOrderSession) {
    return preOrderSession;
  }

  let pOrderTime = parse(preorderTime, "HH:mm", new Date()).getTime();
  // let sessionTimingsEntries = Object.entries(SESSION_TIMINGS);
  let sessionTimingsEntries = Object.entries(sessionsData);
  for (let i = 0; i < sessionTimingsEntries.length; i++) {
    let currentSessionDetails = sessionTimingsEntries[i];
    let [sessStartTime, sessEndTime] = currentSessionDetails[1].split("-");
    sessStartTime = parse(sessStartTime, "HH:mm", new Date()).getTime();
    sessEndTime = parse(sessEndTime, "HH:mm", new Date()).getTime();
    if (
      isWithinInterval(pOrderTime, {
        start: sessStartTime,
        end: sessEndTime
      })
    ) {
      preOrderSession = currentSessionDetails[0];
      break;
    }
  }

  return preOrderSession;
};

export const LOWER_CASE_LIST = (list = []) => {
  return list.map(li => li.toLowerCase());
};



// WEBPACK FOOTER //
// ./src/utils/CommonFunctions.js